
// PROJECT FIELDS:
//
// color
// companyId
// icon
// id
// name
// parent ????
// parentId - parent project id
// role - user's role in project (access needed)
// shortName
// systemStatus
// systemType

import {ProjectTree} from "./@type";
import {ProjectSystemType} from "../../model2/project/types";

const debug = false
// const debug = "ProjectsCollection"

export default class ProjectsCollection {

    public _models          : ProjectTree[] = []
    // public menuProjects     : any
    public _byId            : {
        [id: ID]: ProjectTree // Number keys, string values
    } = {}

    constructor(context:any, data:any, parentProject:ProjectTree|null) {

        this._models    = [];

        const tempArr   = data.slice(0);


        tempArr.map((el:any)=>{

            // children [] -> Collection
            if (el.children && el.children.length>0) {
                el.children = new ProjectsCollection(context, el.children, el);
            }

            // set parent - a ecli net ego ???
            el.parent = parentProject;


            this._models.push(el);

            // add project to tree
            context._projectsById[el.id] = el;
        });

        this.remap();
    }

    get mainMenuProjects() {

        debug && console.log(debug, 'mainMenuProjects', this._models)

        let menuProjects:any[] = []
        _.map(this._models, (project:any)=>{
            if (project.access) {
                menuProjects.push(project)
            } else if (project.children) {
                menuProjects = menuProjects.concat(this._recursiveMenuFinder(project.children._models))
            }
        })

        menuProjects    = _(menuProjects)
            .uniqBy(project=>project.id)
            .sortBy('name')
            .value()

        debug && console.log(debug, 'mainMenuProjects menuProjects', menuProjects)

        return menuProjects
    }

    _recursiveMenuFinder(projects:any, res:any[] = []):any[] {
        _.some(projects, (project:any)=>{

            // if can see all project parents then find root parent and res should contain only this root parent
            if (gd.company.settings.projectAccess.showParentsDespiteAccess) {
                const parentsIds = gd.session.projects.getAllParentsIds(project.id)
                parentsIds[0] && res.push(this.get(parentsIds[0]))
                debug && console.log(debug, '_recursiveMenuFinder add root', res)
                return true
            } else if (project.access) {
                debug && console.log(debug, '_recursiveMenuFinder add by access', res)
                res.push(project)
            } else if (project.children) {
                res = this._recursiveMenuFinder(project.children._models, res)
            }
        })

        debug && console.log(debug, '_recursiveMenuFinder return', res, projects)

        return res
    }

    get hasAccessibleChildren(): boolean {
        const checkAccessible = (projects:any):boolean => (
            _.some(projects, (project:any)=>{
                if (project.access) {
                    return true
                } else if (project.children) {
                    return checkAccessible(project.children._models)
                }
                return false
            })
        )

        return checkAccessible(this._models)
    }

    get sortedByName() {
        return _.sortBy(this._models, 'name');
    }

    get(id:ID) {
        return this._byId[id];
    }

    remap() {

        this._byId = {};
        this._models.map((el:any)=>{
            this._byId[el.id] = el;
        })

    }

    list() {
        return this._models;
    }

    get views():ProjectTree[] {
        return _.filter(this._models, (project: ProjectTree)=>{
            return project.systemType === ProjectSystemType.VIEW
        })
    }

}
